import { object, string, number, array } from "yup";
import { isHTMLContentEmpty } from "helpers/common";
import { dateRequiredSchema, numberRequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import * as Yup from "yup";

const taskPlanSchema = object().shape({

	client_type: string().required("Client type is required"),

	// 1. School
	school: object().when("client_type", {
		is: "school",
		then: (schema) => schema.shape({
			label: stringRequiredSchema,
			value: numberRequiredSchema
		}).required("This field is required"),
		otherwise: (schema) => schema.nullable()
	}),

	date: dateRequiredSchema,
	support_staffs: array()
		.of(
			object().shape({
				staff_id: object()
					.shape({
						label: stringRequiredSchema,
						value: numberRequiredSchema,
					})
					.nullable()
					.required("Support staff is required"),
			})
		)
		.min(1, "At least one support staff is required"),


	// 2️⃣ Clients
	clients: array()
		.of(
			object().shape({
				grade: object()
					.shape({
						label: stringRequiredSchema,
						value: stringRequiredSchema,
					})
					.required("Grade is required"),
				client_id: object()
					.shape({
						label: stringRequiredSchema,
						value: numberRequiredSchema,
					})
					.required("Client is required"),
			})
		)
		.min(1, "At least one client is required"),

	// 3️⃣ Tasks
	tasks: array()
		.of(
			object().shape({
				task_title: string()
					.required("Task title is required"),



				description: string()
					.test(
						"description-required",
						"Description is required",
						(value) => !isHTMLContentEmpty(value)
					),

				// attachments: array().of(
				// 	object().shape({
				// 		attachment_key: string().required(),
				// 		attachment_name: string().required(),
				// 	})
				// ),
				strategy: Yup.array().of(
					Yup.object().shape({
						text: Yup.string().required("Strategy is required"),
						attachments: Yup.array().nullable(),
						template_id: Yup.string().nullable(),
						strategyRadio: Yup.string().nullable()
					})
				)

			})
		)
		.min(1, "At least one task is required")
		.max(4, "Maximum 4 tasks allowed"),

	// 4️⃣ Frequency
	plan_name: stringRequiredSchema,
	// plan_description: string()
	// 	.test(
	// 		"plan-description-required",
	// 		"Plan Description is required",
	// 		(value) => !isHTMLContentEmpty(value)
	// 	),


	// start_date: dateRequiredSchema,

	// end_date: dateRequiredSchema,

	no_of_sessions: numberRequiredSchema
		.min(1, "Minimum 1 session is required")
		.max(12, "Maximum 12 sessions allowed"),
});

export default taskPlanSchema;
